import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSupplierOffer() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      productCount:
        isEmpty(state.productCount) ||
        state.productCount == 0 ||
        state.productCount == "0",
    };

    setter(errorState);

    if (errorState.productCount) {
      enqueueSnackbar("لطفا تعداد درخواستی را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getOfferList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_SupplierOffers?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllOfferList = (callback) => {
    MyAxios.get(`Admin_SupplierOffers?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOfferByID = (id, callback) => {
    MyAxios.get(`Admin_SupplierOffers/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addOffer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierOffers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("پیشنهاد با موفقیت ثبت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const cancelOffer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.delete(`Admin_SupplierOffers`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("پیشنهاد با موفقیت لغو شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getOfferList,
    getAllOfferList,
    getOfferByID,
    validate,
    addOffer,
    cancelOffer,
  };
}
